import { Injectable } from '@angular/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';

@Injectable({
    providedIn: 'root'
})
export class LocalNotification {

    constructor() { }

    async sendNotification(id: number, seconds = 0) {
        if (!Capacitor.isNativePlatform()) {
            return;
        }

        try {
            // Request permission first
            const permissionResult = await LocalNotifications.checkPermissions();
            if (permissionResult.display !== 'granted') {
                const requestResult = await LocalNotifications.requestPermissions();
                if (requestResult.display !== 'granted') {
                    console.warn('Local notification permissions not granted');
                    return;
                }
            }

            // Schedule notification
            await LocalNotifications.schedule({
                notifications: [
                    {
                        title: "Time's up",
                        body: "Time's up",
                        id: id,
                        schedule: {
                            at: new Date(Date.now() + seconds * 1000)
                        }
                    }
                ]
            });
        } catch (error) {
            console.error('Error scheduling local notification:', error);
        }
    }

    async cancelNotification(id: number) {
        if (!Capacitor.isNativePlatform()) {
            return;
        }

        try {
            await LocalNotifications.cancel({
                notifications: [{ id: id }]
            });
        } catch (error) {
            console.error('Error canceling local notification:', error);
        }
    }   
}